var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackShipmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.3307C12.0697 13.3307 12.6667 12.7338 12.6667 11.9974C12.6667 11.261 12.0697 10.6641 11.3333 10.6641C10.597 10.6641 10 11.261 10 11.9974C10 12.7338 10.597 13.3307 11.3333 13.3307Z",
    stroke: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66927 13.3307C5.40565 13.3307 6.0026 12.7338 6.0026 11.9974C6.0026 11.261 5.40565 10.6641 4.66927 10.6641C3.93289 10.6641 3.33594 11.261 3.33594 11.9974C3.33594 12.7338 3.93289 13.3307 4.66927 13.3307Z",
    stroke: "#22428F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 11.3307H10.0026M9.0026 4.66406H9.6312C10.5048 4.66406 10.9417 4.66406 11.312 4.87374C11.6823 5.08342 11.9293 5.47054 12.4231 6.24478C12.7694 6.78766 13.1329 7.18173 13.6441 7.53233C14.1587 7.88526 14.4034 8.0578 14.5392 8.33473C14.6693 8.59993 14.6693 8.91406 14.6693 9.54226C14.6693 10.3705 14.6693 10.7846 14.4366 11.0477C14.4266 11.0591 14.4164 11.0701 14.4059 11.0807C14.1609 11.3307 13.7755 11.3307 13.0046 11.3307H12.6693",
    stroke: "#22428F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 4.66406L9.32686 6.3211C9.6516 7.133 9.814 7.53893 10.1526 7.76813C10.4912 7.9974 10.9284 7.9974 11.8028 7.9974H13.9974",
    stroke: "#22428F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24898 11.3307C2.34716 11.3307 1.89626 11.3307 1.6161 11.0379C1.33594 10.7449 1.33594 10.2735 1.33594 9.33073V4.66406C1.33594 3.72126 1.33594 3.24985 1.6161 2.95696C1.89626 2.66406 2.34716 2.66406 3.24898 2.66406H6.7562C7.65807 2.66406 8.10894 2.66406 8.38914 2.95696C8.66927 3.24985 8.66927 3.72126 8.66927 4.66406V11.3307H5.7997",
    stroke: "#22428F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackShipmentIcon);
export default __webpack_public_path__ + "static/media/track-shipment-icon.cf6b8bcdeb5c540a4dff294036ae1e30.svg";
export { ForwardRef as ReactComponent };